/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedRolesRouteImport } from './routes/_authenticated/roles'
import { Route as AuthenticatedEmployeesRouteImport } from './routes/_authenticated/employees'
import { Route as AuthenticatedCeleryRouteImport } from './routes/_authenticated/celery'
import { Route as AuthenticatedAuditLogsRouteImport } from './routes/_authenticated/audit-logs'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedProfileRouteRouteImport } from './routes/_authenticated/profile/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSubscriptionsIndexRouteImport } from './routes/_authenticated/subscriptions/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedPartnersIndexRouteImport } from './routes/_authenticated/partners/index'
import { Route as AuthenticatedOrdersIndexRouteImport } from './routes/_authenticated/orders/index'
import { Route as AuthenticatedMonitoringIndexRouteImport } from './routes/_authenticated/monitoring/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedSubscriptionsProvidersRouteImport } from './routes/_authenticated/subscriptions/providers'
import { Route as AuthenticatedSubscriptionsSubsIdRouteImport } from './routes/_authenticated/subscriptions/$subsId'
import { Route as AuthenticatedProductsCategoriesRouteImport } from './routes/_authenticated/products/categories'
import { Route as AuthenticatedOrdersNewRouteImport } from './routes/_authenticated/orders/new'
import { Route as AuthenticatedOrdersOrderIdRouteImport } from './routes/_authenticated/orders/$orderId'
import { Route as AuthenticatedMonitoringUnconfiguredRouteImport } from './routes/_authenticated/monitoring/unconfigured'
import { Route as AuthenticatedMonitoringStatusMismatchRouteImport } from './routes/_authenticated/monitoring/status-mismatch'
import { Route as AuthenticatedMonitoringPppoeRouteImport } from './routes/_authenticated/monitoring/pppoe'
import { Route as AuthenticatedMonitoringOnusRouteImport } from './routes/_authenticated/monitoring/onus'
import { Route as AuthenticatedMonitoringOltsRouteImport } from './routes/_authenticated/monitoring/olts'
import { Route as AuthenticatedMonitoringDownloadsRouteImport } from './routes/_authenticated/monitoring/downloads'
import { Route as AuthenticatedMarketingTemplatesRouteImport } from './routes/_authenticated/marketing/templates'
import { Route as AuthenticatedInventoryWarehouseRouteImport } from './routes/_authenticated/inventory/warehouse'
import { Route as AuthenticatedInventoryStockRouteImport } from './routes/_authenticated/inventory/stock'
import { Route as AuthenticatedInventoryMeRouteImport } from './routes/_authenticated/inventory/me'
import { Route as AuthenticatedInventoryMasterRouteImport } from './routes/_authenticated/inventory/master'
import { Route as AuthenticatedInventoryLedgerRouteImport } from './routes/_authenticated/inventory/ledger'
import { Route as AuthenticatedInventoryDocumentsRouteImport } from './routes/_authenticated/inventory/documents'
import { Route as AuthenticatedInventoryControlRouteImport } from './routes/_authenticated/inventory/control'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedDevicesSplittersRouteImport } from './routes/_authenticated/devices/splitters'
import { Route as AuthenticatedDevicesOnusRouteImport } from './routes/_authenticated/devices/onus'
import { Route as AuthenticatedDevicesOltsRouteImport } from './routes/_authenticated/devices/olts'
import { Route as AuthenticatedDevicesOltCardsRouteImport } from './routes/_authenticated/devices/olt-cards'
import { Route as AuthenticatedDevicesMikrotiksRouteImport } from './routes/_authenticated/devices/mikrotiks'
import { Route as AuthenticatedDevicesCoverageAreasRouteImport } from './routes/_authenticated/devices/coverage-areas'
import { Route as AuthenticatedCustomersNewRouteImport } from './routes/_authenticated/customers/new'
import { Route as AuthenticatedCustomersCustomerIdRouteImport } from './routes/_authenticated/customers/$customerId'
import { Route as AuthenticatedBillingInvoicesRouteImport } from './routes/_authenticated/billing/invoices'
import { Route as AuthenticatedBillingHubInvoicesRouteImport } from './routes/_authenticated/billing/hub-invoices'
import { Route as AuthenticatedBillingDiscountsRouteImport } from './routes/_authenticated/billing/discounts'
import { Route as AuthenticatedBillingDiscountVouchersRouteImport } from './routes/_authenticated/billing/discount-vouchers'
import { Route as AuthenticatedBillingCustomerPointsRouteImport } from './routes/_authenticated/billing/customer-points'
import { Route as AuthenticatedBillingBillingCyclesRouteImport } from './routes/_authenticated/billing/billing-cycles'
import { Route as AuthenticatedOperationBillingRunHistoryIndexRouteImport } from './routes/_authenticated/operation/billing-run-history/index'
import { Route as AuthenticatedOperationBillingEngineRunIndexRouteImport } from './routes/_authenticated/operation/billing-engine-run/index'
import { Route as AuthenticatedMarketingBroadcastIndexRouteImport } from './routes/_authenticated/marketing/broadcast/index'
import { Route as AuthenticatedOperationBillingRunHistoryRunIdRouteImport } from './routes/_authenticated/operation/billing-run-history/$runId'
import { Route as AuthenticatedMarketingBroadcastNewRouteImport } from './routes/_authenticated/marketing/broadcast/new'
import { Route as AuthenticatedMarketingBroadcastBroadcastIdRouteImport } from './routes/_authenticated/marketing/broadcast/$broadcastId'

const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRolesRoute = AuthenticatedRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedEmployeesRoute = AuthenticatedEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCeleryRoute = AuthenticatedCeleryRouteImport.update({
  id: '/celery',
  path: '/celery',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAuditLogsRoute = AuthenticatedAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileRouteRoute =
  AuthenticatedProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSubscriptionsIndexRoute =
  AuthenticatedSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartnersIndexRoute =
  AuthenticatedPartnersIndexRouteImport.update({
    id: '/partners/',
    path: '/partners/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersIndexRoute =
  AuthenticatedOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringIndexRoute =
  AuthenticatedMonitoringIndexRouteImport.update({
    id: '/monitoring/',
    path: '/monitoring/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedSubscriptionsProvidersRoute =
  AuthenticatedSubscriptionsProvidersRouteImport.update({
    id: '/subscriptions/providers',
    path: '/subscriptions/providers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSubscriptionsSubsIdRoute =
  AuthenticatedSubscriptionsSubsIdRouteImport.update({
    id: '/subscriptions/$subsId',
    path: '/subscriptions/$subsId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsCategoriesRoute =
  AuthenticatedProductsCategoriesRouteImport.update({
    id: '/products/categories',
    path: '/products/categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersNewRoute = AuthenticatedOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrdersOrderIdRoute =
  AuthenticatedOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringUnconfiguredRoute =
  AuthenticatedMonitoringUnconfiguredRouteImport.update({
    id: '/monitoring/unconfigured',
    path: '/monitoring/unconfigured',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringStatusMismatchRoute =
  AuthenticatedMonitoringStatusMismatchRouteImport.update({
    id: '/monitoring/status-mismatch',
    path: '/monitoring/status-mismatch',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringPppoeRoute =
  AuthenticatedMonitoringPppoeRouteImport.update({
    id: '/monitoring/pppoe',
    path: '/monitoring/pppoe',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringOnusRoute =
  AuthenticatedMonitoringOnusRouteImport.update({
    id: '/monitoring/onus',
    path: '/monitoring/onus',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringOltsRoute =
  AuthenticatedMonitoringOltsRouteImport.update({
    id: '/monitoring/olts',
    path: '/monitoring/olts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringDownloadsRoute =
  AuthenticatedMonitoringDownloadsRouteImport.update({
    id: '/monitoring/downloads',
    path: '/monitoring/downloads',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarketingTemplatesRoute =
  AuthenticatedMarketingTemplatesRouteImport.update({
    id: '/marketing/templates',
    path: '/marketing/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryWarehouseRoute =
  AuthenticatedInventoryWarehouseRouteImport.update({
    id: '/inventory/warehouse',
    path: '/inventory/warehouse',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryStockRoute =
  AuthenticatedInventoryStockRouteImport.update({
    id: '/inventory/stock',
    path: '/inventory/stock',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryMeRoute =
  AuthenticatedInventoryMeRouteImport.update({
    id: '/inventory/me',
    path: '/inventory/me',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryMasterRoute =
  AuthenticatedInventoryMasterRouteImport.update({
    id: '/inventory/master',
    path: '/inventory/master',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryLedgerRoute =
  AuthenticatedInventoryLedgerRouteImport.update({
    id: '/inventory/ledger',
    path: '/inventory/ledger',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryDocumentsRoute =
  AuthenticatedInventoryDocumentsRouteImport.update({
    id: '/inventory/documents',
    path: '/inventory/documents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInventoryControlRoute =
  AuthenticatedInventoryControlRouteImport.update({
    id: '/inventory/control',
    path: '/inventory/control',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesSplittersRoute =
  AuthenticatedDevicesSplittersRouteImport.update({
    id: '/devices/splitters',
    path: '/devices/splitters',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesOnusRoute =
  AuthenticatedDevicesOnusRouteImport.update({
    id: '/devices/onus',
    path: '/devices/onus',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesOltsRoute =
  AuthenticatedDevicesOltsRouteImport.update({
    id: '/devices/olts',
    path: '/devices/olts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesOltCardsRoute =
  AuthenticatedDevicesOltCardsRouteImport.update({
    id: '/devices/olt-cards',
    path: '/devices/olt-cards',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesMikrotiksRoute =
  AuthenticatedDevicesMikrotiksRouteImport.update({
    id: '/devices/mikrotiks',
    path: '/devices/mikrotiks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevicesCoverageAreasRoute =
  AuthenticatedDevicesCoverageAreasRouteImport.update({
    id: '/devices/coverage-areas',
    path: '/devices/coverage-areas',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersNewRoute =
  AuthenticatedCustomersNewRouteImport.update({
    id: '/customers/new',
    path: '/customers/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingInvoicesRoute =
  AuthenticatedBillingInvoicesRouteImport.update({
    id: '/billing/invoices',
    path: '/billing/invoices',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingHubInvoicesRoute =
  AuthenticatedBillingHubInvoicesRouteImport.update({
    id: '/billing/hub-invoices',
    path: '/billing/hub-invoices',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingDiscountsRoute =
  AuthenticatedBillingDiscountsRouteImport.update({
    id: '/billing/discounts',
    path: '/billing/discounts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingDiscountVouchersRoute =
  AuthenticatedBillingDiscountVouchersRouteImport.update({
    id: '/billing/discount-vouchers',
    path: '/billing/discount-vouchers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingCustomerPointsRoute =
  AuthenticatedBillingCustomerPointsRouteImport.update({
    id: '/billing/customer-points',
    path: '/billing/customer-points',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingBillingCyclesRoute =
  AuthenticatedBillingBillingCyclesRouteImport.update({
    id: '/billing/billing-cycles',
    path: '/billing/billing-cycles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationBillingRunHistoryIndexRoute =
  AuthenticatedOperationBillingRunHistoryIndexRouteImport.update({
    id: '/operation/billing-run-history/',
    path: '/operation/billing-run-history/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationBillingEngineRunIndexRoute =
  AuthenticatedOperationBillingEngineRunIndexRouteImport.update({
    id: '/operation/billing-engine-run/',
    path: '/operation/billing-engine-run/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarketingBroadcastIndexRoute =
  AuthenticatedMarketingBroadcastIndexRouteImport.update({
    id: '/marketing/broadcast/',
    path: '/marketing/broadcast/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationBillingRunHistoryRunIdRoute =
  AuthenticatedOperationBillingRunHistoryRunIdRouteImport.update({
    id: '/operation/billing-run-history/$runId',
    path: '/operation/billing-run-history/$runId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarketingBroadcastNewRoute =
  AuthenticatedMarketingBroadcastNewRouteImport.update({
    id: '/marketing/broadcast/new',
    path: '/marketing/broadcast/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarketingBroadcastBroadcastIdRoute =
  AuthenticatedMarketingBroadcastBroadcastIdRouteImport.update({
    id: '/marketing/broadcast/$broadcastId',
    path: '/marketing/broadcast/$broadcastId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/clerk': typeof ClerkauthRouteRouteWithChildren
  '/profile': typeof AuthenticatedProfileRouteRoute
  '/settings': typeof AuthenticatedSettingsRouteRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/celery': typeof AuthenticatedCeleryRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/roles': typeof AuthenticatedRolesRoute
  '/billing/billing-cycles': typeof AuthenticatedBillingBillingCyclesRoute
  '/billing/customer-points': typeof AuthenticatedBillingCustomerPointsRoute
  '/billing/discount-vouchers': typeof AuthenticatedBillingDiscountVouchersRoute
  '/billing/discounts': typeof AuthenticatedBillingDiscountsRoute
  '/billing/hub-invoices': typeof AuthenticatedBillingHubInvoicesRoute
  '/billing/invoices': typeof AuthenticatedBillingInvoicesRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers/new': typeof AuthenticatedCustomersNewRoute
  '/devices/coverage-areas': typeof AuthenticatedDevicesCoverageAreasRoute
  '/devices/mikrotiks': typeof AuthenticatedDevicesMikrotiksRoute
  '/devices/olt-cards': typeof AuthenticatedDevicesOltCardsRoute
  '/devices/olts': typeof AuthenticatedDevicesOltsRoute
  '/devices/onus': typeof AuthenticatedDevicesOnusRoute
  '/devices/splitters': typeof AuthenticatedDevicesSplittersRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/inventory/control': typeof AuthenticatedInventoryControlRoute
  '/inventory/documents': typeof AuthenticatedInventoryDocumentsRoute
  '/inventory/ledger': typeof AuthenticatedInventoryLedgerRoute
  '/inventory/master': typeof AuthenticatedInventoryMasterRoute
  '/inventory/me': typeof AuthenticatedInventoryMeRoute
  '/inventory/stock': typeof AuthenticatedInventoryStockRoute
  '/inventory/warehouse': typeof AuthenticatedInventoryWarehouseRoute
  '/marketing/templates': typeof AuthenticatedMarketingTemplatesRoute
  '/monitoring/downloads': typeof AuthenticatedMonitoringDownloadsRoute
  '/monitoring/olts': typeof AuthenticatedMonitoringOltsRoute
  '/monitoring/onus': typeof AuthenticatedMonitoringOnusRoute
  '/monitoring/pppoe': typeof AuthenticatedMonitoringPppoeRoute
  '/monitoring/status-mismatch': typeof AuthenticatedMonitoringStatusMismatchRoute
  '/monitoring/unconfigured': typeof AuthenticatedMonitoringUnconfiguredRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/orders/new': typeof AuthenticatedOrdersNewRoute
  '/products/categories': typeof AuthenticatedProductsCategoriesRoute
  '/subscriptions/$subsId': typeof AuthenticatedSubscriptionsSubsIdRoute
  '/subscriptions/providers': typeof AuthenticatedSubscriptionsProvidersRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/apps/': typeof AuthenticatedAppsIndexRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/monitoring/': typeof AuthenticatedMonitoringIndexRoute
  '/orders/': typeof AuthenticatedOrdersIndexRoute
  '/partners/': typeof AuthenticatedPartnersIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/subscriptions/': typeof AuthenticatedSubscriptionsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/marketing/broadcast/$broadcastId': typeof AuthenticatedMarketingBroadcastBroadcastIdRoute
  '/marketing/broadcast/new': typeof AuthenticatedMarketingBroadcastNewRoute
  '/operation/billing-run-history/$runId': typeof AuthenticatedOperationBillingRunHistoryRunIdRoute
  '/marketing/broadcast/': typeof AuthenticatedMarketingBroadcastIndexRoute
  '/operation/billing-engine-run/': typeof AuthenticatedOperationBillingEngineRunIndexRoute
  '/operation/billing-run-history/': typeof AuthenticatedOperationBillingRunHistoryIndexRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkauthRouteRouteWithChildren
  '/profile': typeof AuthenticatedProfileRouteRoute
  '/settings': typeof AuthenticatedSettingsRouteRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/celery': typeof AuthenticatedCeleryRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/roles': typeof AuthenticatedRolesRoute
  '/': typeof AuthenticatedIndexRoute
  '/billing/billing-cycles': typeof AuthenticatedBillingBillingCyclesRoute
  '/billing/customer-points': typeof AuthenticatedBillingCustomerPointsRoute
  '/billing/discount-vouchers': typeof AuthenticatedBillingDiscountVouchersRoute
  '/billing/discounts': typeof AuthenticatedBillingDiscountsRoute
  '/billing/hub-invoices': typeof AuthenticatedBillingHubInvoicesRoute
  '/billing/invoices': typeof AuthenticatedBillingInvoicesRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers/new': typeof AuthenticatedCustomersNewRoute
  '/devices/coverage-areas': typeof AuthenticatedDevicesCoverageAreasRoute
  '/devices/mikrotiks': typeof AuthenticatedDevicesMikrotiksRoute
  '/devices/olt-cards': typeof AuthenticatedDevicesOltCardsRoute
  '/devices/olts': typeof AuthenticatedDevicesOltsRoute
  '/devices/onus': typeof AuthenticatedDevicesOnusRoute
  '/devices/splitters': typeof AuthenticatedDevicesSplittersRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/inventory/control': typeof AuthenticatedInventoryControlRoute
  '/inventory/documents': typeof AuthenticatedInventoryDocumentsRoute
  '/inventory/ledger': typeof AuthenticatedInventoryLedgerRoute
  '/inventory/master': typeof AuthenticatedInventoryMasterRoute
  '/inventory/me': typeof AuthenticatedInventoryMeRoute
  '/inventory/stock': typeof AuthenticatedInventoryStockRoute
  '/inventory/warehouse': typeof AuthenticatedInventoryWarehouseRoute
  '/marketing/templates': typeof AuthenticatedMarketingTemplatesRoute
  '/monitoring/downloads': typeof AuthenticatedMonitoringDownloadsRoute
  '/monitoring/olts': typeof AuthenticatedMonitoringOltsRoute
  '/monitoring/onus': typeof AuthenticatedMonitoringOnusRoute
  '/monitoring/pppoe': typeof AuthenticatedMonitoringPppoeRoute
  '/monitoring/status-mismatch': typeof AuthenticatedMonitoringStatusMismatchRoute
  '/monitoring/unconfigured': typeof AuthenticatedMonitoringUnconfiguredRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/orders/new': typeof AuthenticatedOrdersNewRoute
  '/products/categories': typeof AuthenticatedProductsCategoriesRoute
  '/subscriptions/$subsId': typeof AuthenticatedSubscriptionsSubsIdRoute
  '/subscriptions/providers': typeof AuthenticatedSubscriptionsProvidersRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/monitoring': typeof AuthenticatedMonitoringIndexRoute
  '/orders': typeof AuthenticatedOrdersIndexRoute
  '/partners': typeof AuthenticatedPartnersIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/marketing/broadcast/$broadcastId': typeof AuthenticatedMarketingBroadcastBroadcastIdRoute
  '/marketing/broadcast/new': typeof AuthenticatedMarketingBroadcastNewRoute
  '/operation/billing-run-history/$runId': typeof AuthenticatedOperationBillingRunHistoryRunIdRoute
  '/marketing/broadcast': typeof AuthenticatedMarketingBroadcastIndexRoute
  '/operation/billing-engine-run': typeof AuthenticatedOperationBillingEngineRunIndexRoute
  '/operation/billing-run-history': typeof AuthenticatedOperationBillingRunHistoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRouteRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRoute
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/_authenticated/celery': typeof AuthenticatedCeleryRoute
  '/_authenticated/employees': typeof AuthenticatedEmployeesRoute
  '/_authenticated/roles': typeof AuthenticatedRolesRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/billing/billing-cycles': typeof AuthenticatedBillingBillingCyclesRoute
  '/_authenticated/billing/customer-points': typeof AuthenticatedBillingCustomerPointsRoute
  '/_authenticated/billing/discount-vouchers': typeof AuthenticatedBillingDiscountVouchersRoute
  '/_authenticated/billing/discounts': typeof AuthenticatedBillingDiscountsRoute
  '/_authenticated/billing/hub-invoices': typeof AuthenticatedBillingHubInvoicesRoute
  '/_authenticated/billing/invoices': typeof AuthenticatedBillingInvoicesRoute
  '/_authenticated/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/_authenticated/customers/new': typeof AuthenticatedCustomersNewRoute
  '/_authenticated/devices/coverage-areas': typeof AuthenticatedDevicesCoverageAreasRoute
  '/_authenticated/devices/mikrotiks': typeof AuthenticatedDevicesMikrotiksRoute
  '/_authenticated/devices/olt-cards': typeof AuthenticatedDevicesOltCardsRoute
  '/_authenticated/devices/olts': typeof AuthenticatedDevicesOltsRoute
  '/_authenticated/devices/onus': typeof AuthenticatedDevicesOnusRoute
  '/_authenticated/devices/splitters': typeof AuthenticatedDevicesSplittersRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/inventory/control': typeof AuthenticatedInventoryControlRoute
  '/_authenticated/inventory/documents': typeof AuthenticatedInventoryDocumentsRoute
  '/_authenticated/inventory/ledger': typeof AuthenticatedInventoryLedgerRoute
  '/_authenticated/inventory/master': typeof AuthenticatedInventoryMasterRoute
  '/_authenticated/inventory/me': typeof AuthenticatedInventoryMeRoute
  '/_authenticated/inventory/stock': typeof AuthenticatedInventoryStockRoute
  '/_authenticated/inventory/warehouse': typeof AuthenticatedInventoryWarehouseRoute
  '/_authenticated/marketing/templates': typeof AuthenticatedMarketingTemplatesRoute
  '/_authenticated/monitoring/downloads': typeof AuthenticatedMonitoringDownloadsRoute
  '/_authenticated/monitoring/olts': typeof AuthenticatedMonitoringOltsRoute
  '/_authenticated/monitoring/onus': typeof AuthenticatedMonitoringOnusRoute
  '/_authenticated/monitoring/pppoe': typeof AuthenticatedMonitoringPppoeRoute
  '/_authenticated/monitoring/status-mismatch': typeof AuthenticatedMonitoringStatusMismatchRoute
  '/_authenticated/monitoring/unconfigured': typeof AuthenticatedMonitoringUnconfiguredRoute
  '/_authenticated/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/_authenticated/orders/new': typeof AuthenticatedOrdersNewRoute
  '/_authenticated/products/categories': typeof AuthenticatedProductsCategoriesRoute
  '/_authenticated/subscriptions/$subsId': typeof AuthenticatedSubscriptionsSubsIdRoute
  '/_authenticated/subscriptions/providers': typeof AuthenticatedSubscriptionsProvidersRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/monitoring/': typeof AuthenticatedMonitoringIndexRoute
  '/_authenticated/orders/': typeof AuthenticatedOrdersIndexRoute
  '/_authenticated/partners/': typeof AuthenticatedPartnersIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/subscriptions/': typeof AuthenticatedSubscriptionsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/marketing/broadcast/$broadcastId': typeof AuthenticatedMarketingBroadcastBroadcastIdRoute
  '/_authenticated/marketing/broadcast/new': typeof AuthenticatedMarketingBroadcastNewRoute
  '/_authenticated/operation/billing-run-history/$runId': typeof AuthenticatedOperationBillingRunHistoryRunIdRoute
  '/_authenticated/marketing/broadcast/': typeof AuthenticatedMarketingBroadcastIndexRoute
  '/_authenticated/operation/billing-engine-run/': typeof AuthenticatedOperationBillingEngineRunIndexRoute
  '/_authenticated/operation/billing-run-history/': typeof AuthenticatedOperationBillingRunHistoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clerk'
    | '/profile'
    | '/settings'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/audit-logs'
    | '/celery'
    | '/employees'
    | '/roles'
    | '/billing/billing-cycles'
    | '/billing/customer-points'
    | '/billing/discount-vouchers'
    | '/billing/discounts'
    | '/billing/hub-invoices'
    | '/billing/invoices'
    | '/customers/$customerId'
    | '/customers/new'
    | '/devices/coverage-areas'
    | '/devices/mikrotiks'
    | '/devices/olt-cards'
    | '/devices/olts'
    | '/devices/onus'
    | '/devices/splitters'
    | '/errors/$error'
    | '/inventory/control'
    | '/inventory/documents'
    | '/inventory/ledger'
    | '/inventory/master'
    | '/inventory/me'
    | '/inventory/stock'
    | '/inventory/warehouse'
    | '/marketing/templates'
    | '/monitoring/downloads'
    | '/monitoring/olts'
    | '/monitoring/onus'
    | '/monitoring/pppoe'
    | '/monitoring/status-mismatch'
    | '/monitoring/unconfigured'
    | '/orders/$orderId'
    | '/orders/new'
    | '/products/categories'
    | '/subscriptions/$subsId'
    | '/subscriptions/providers'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/apps/'
    | '/chats/'
    | '/customers/'
    | '/help-center/'
    | '/monitoring/'
    | '/orders/'
    | '/partners/'
    | '/products/'
    | '/subscriptions/'
    | '/tasks/'
    | '/users/'
    | '/marketing/broadcast/$broadcastId'
    | '/marketing/broadcast/new'
    | '/operation/billing-run-history/$runId'
    | '/marketing/broadcast/'
    | '/operation/billing-engine-run/'
    | '/operation/billing-run-history/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/profile'
    | '/settings'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/audit-logs'
    | '/celery'
    | '/employees'
    | '/roles'
    | '/'
    | '/billing/billing-cycles'
    | '/billing/customer-points'
    | '/billing/discount-vouchers'
    | '/billing/discounts'
    | '/billing/hub-invoices'
    | '/billing/invoices'
    | '/customers/$customerId'
    | '/customers/new'
    | '/devices/coverage-areas'
    | '/devices/mikrotiks'
    | '/devices/olt-cards'
    | '/devices/olts'
    | '/devices/onus'
    | '/devices/splitters'
    | '/errors/$error'
    | '/inventory/control'
    | '/inventory/documents'
    | '/inventory/ledger'
    | '/inventory/master'
    | '/inventory/me'
    | '/inventory/stock'
    | '/inventory/warehouse'
    | '/marketing/templates'
    | '/monitoring/downloads'
    | '/monitoring/olts'
    | '/monitoring/onus'
    | '/monitoring/pppoe'
    | '/monitoring/status-mismatch'
    | '/monitoring/unconfigured'
    | '/orders/$orderId'
    | '/orders/new'
    | '/products/categories'
    | '/subscriptions/$subsId'
    | '/subscriptions/providers'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/apps'
    | '/chats'
    | '/customers'
    | '/help-center'
    | '/monitoring'
    | '/orders'
    | '/partners'
    | '/products'
    | '/subscriptions'
    | '/tasks'
    | '/users'
    | '/marketing/broadcast/$broadcastId'
    | '/marketing/broadcast/new'
    | '/operation/billing-run-history/$runId'
    | '/marketing/broadcast'
    | '/operation/billing-engine-run'
    | '/operation/billing-run-history'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/_authenticated/profile'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/audit-logs'
    | '/_authenticated/celery'
    | '/_authenticated/employees'
    | '/_authenticated/roles'
    | '/_authenticated/'
    | '/_authenticated/billing/billing-cycles'
    | '/_authenticated/billing/customer-points'
    | '/_authenticated/billing/discount-vouchers'
    | '/_authenticated/billing/discounts'
    | '/_authenticated/billing/hub-invoices'
    | '/_authenticated/billing/invoices'
    | '/_authenticated/customers/$customerId'
    | '/_authenticated/customers/new'
    | '/_authenticated/devices/coverage-areas'
    | '/_authenticated/devices/mikrotiks'
    | '/_authenticated/devices/olt-cards'
    | '/_authenticated/devices/olts'
    | '/_authenticated/devices/onus'
    | '/_authenticated/devices/splitters'
    | '/_authenticated/errors/$error'
    | '/_authenticated/inventory/control'
    | '/_authenticated/inventory/documents'
    | '/_authenticated/inventory/ledger'
    | '/_authenticated/inventory/master'
    | '/_authenticated/inventory/me'
    | '/_authenticated/inventory/stock'
    | '/_authenticated/inventory/warehouse'
    | '/_authenticated/marketing/templates'
    | '/_authenticated/monitoring/downloads'
    | '/_authenticated/monitoring/olts'
    | '/_authenticated/monitoring/onus'
    | '/_authenticated/monitoring/pppoe'
    | '/_authenticated/monitoring/status-mismatch'
    | '/_authenticated/monitoring/unconfigured'
    | '/_authenticated/orders/$orderId'
    | '/_authenticated/orders/new'
    | '/_authenticated/products/categories'
    | '/_authenticated/subscriptions/$subsId'
    | '/_authenticated/subscriptions/providers'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/_authenticated/apps/'
    | '/_authenticated/chats/'
    | '/_authenticated/customers/'
    | '/_authenticated/help-center/'
    | '/_authenticated/monitoring/'
    | '/_authenticated/orders/'
    | '/_authenticated/partners/'
    | '/_authenticated/products/'
    | '/_authenticated/subscriptions/'
    | '/_authenticated/tasks/'
    | '/_authenticated/users/'
    | '/_authenticated/marketing/broadcast/$broadcastId'
    | '/_authenticated/marketing/broadcast/new'
    | '/_authenticated/operation/billing-run-history/$runId'
    | '/_authenticated/marketing/broadcast/'
    | '/_authenticated/operation/billing-engine-run/'
    | '/_authenticated/operation/billing-run-history/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/roles': {
      id: '/_authenticated/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/employees': {
      id: '/_authenticated/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/celery': {
      id: '/_authenticated/celery'
      path: '/celery'
      fullPath: '/celery'
      preLoaderRoute: typeof AuthenticatedCeleryRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audit-logs': {
      id: '/_authenticated/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuthenticatedAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/subscriptions/': {
      id: '/_authenticated/subscriptions/'
      path: '/subscriptions'
      fullPath: '/subscriptions/'
      preLoaderRoute: typeof AuthenticatedSubscriptionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/partners/': {
      id: '/_authenticated/partners/'
      path: '/partners'
      fullPath: '/partners/'
      preLoaderRoute: typeof AuthenticatedPartnersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/': {
      id: '/_authenticated/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/': {
      id: '/_authenticated/monitoring/'
      path: '/monitoring'
      fullPath: '/monitoring/'
      preLoaderRoute: typeof AuthenticatedMonitoringIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/subscriptions/providers': {
      id: '/_authenticated/subscriptions/providers'
      path: '/subscriptions/providers'
      fullPath: '/subscriptions/providers'
      preLoaderRoute: typeof AuthenticatedSubscriptionsProvidersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/subscriptions/$subsId': {
      id: '/_authenticated/subscriptions/$subsId'
      path: '/subscriptions/$subsId'
      fullPath: '/subscriptions/$subsId'
      preLoaderRoute: typeof AuthenticatedSubscriptionsSubsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/categories': {
      id: '/_authenticated/products/categories'
      path: '/products/categories'
      fullPath: '/products/categories'
      preLoaderRoute: typeof AuthenticatedProductsCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/new': {
      id: '/_authenticated/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AuthenticatedOrdersNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/$orderId': {
      id: '/_authenticated/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/unconfigured': {
      id: '/_authenticated/monitoring/unconfigured'
      path: '/monitoring/unconfigured'
      fullPath: '/monitoring/unconfigured'
      preLoaderRoute: typeof AuthenticatedMonitoringUnconfiguredRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/status-mismatch': {
      id: '/_authenticated/monitoring/status-mismatch'
      path: '/monitoring/status-mismatch'
      fullPath: '/monitoring/status-mismatch'
      preLoaderRoute: typeof AuthenticatedMonitoringStatusMismatchRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/pppoe': {
      id: '/_authenticated/monitoring/pppoe'
      path: '/monitoring/pppoe'
      fullPath: '/monitoring/pppoe'
      preLoaderRoute: typeof AuthenticatedMonitoringPppoeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/onus': {
      id: '/_authenticated/monitoring/onus'
      path: '/monitoring/onus'
      fullPath: '/monitoring/onus'
      preLoaderRoute: typeof AuthenticatedMonitoringOnusRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/olts': {
      id: '/_authenticated/monitoring/olts'
      path: '/monitoring/olts'
      fullPath: '/monitoring/olts'
      preLoaderRoute: typeof AuthenticatedMonitoringOltsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/downloads': {
      id: '/_authenticated/monitoring/downloads'
      path: '/monitoring/downloads'
      fullPath: '/monitoring/downloads'
      preLoaderRoute: typeof AuthenticatedMonitoringDownloadsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marketing/templates': {
      id: '/_authenticated/marketing/templates'
      path: '/marketing/templates'
      fullPath: '/marketing/templates'
      preLoaderRoute: typeof AuthenticatedMarketingTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/warehouse': {
      id: '/_authenticated/inventory/warehouse'
      path: '/inventory/warehouse'
      fullPath: '/inventory/warehouse'
      preLoaderRoute: typeof AuthenticatedInventoryWarehouseRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/stock': {
      id: '/_authenticated/inventory/stock'
      path: '/inventory/stock'
      fullPath: '/inventory/stock'
      preLoaderRoute: typeof AuthenticatedInventoryStockRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/me': {
      id: '/_authenticated/inventory/me'
      path: '/inventory/me'
      fullPath: '/inventory/me'
      preLoaderRoute: typeof AuthenticatedInventoryMeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/master': {
      id: '/_authenticated/inventory/master'
      path: '/inventory/master'
      fullPath: '/inventory/master'
      preLoaderRoute: typeof AuthenticatedInventoryMasterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/ledger': {
      id: '/_authenticated/inventory/ledger'
      path: '/inventory/ledger'
      fullPath: '/inventory/ledger'
      preLoaderRoute: typeof AuthenticatedInventoryLedgerRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/documents': {
      id: '/_authenticated/inventory/documents'
      path: '/inventory/documents'
      fullPath: '/inventory/documents'
      preLoaderRoute: typeof AuthenticatedInventoryDocumentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inventory/control': {
      id: '/_authenticated/inventory/control'
      path: '/inventory/control'
      fullPath: '/inventory/control'
      preLoaderRoute: typeof AuthenticatedInventoryControlRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices/splitters': {
      id: '/_authenticated/devices/splitters'
      path: '/devices/splitters'
      fullPath: '/devices/splitters'
      preLoaderRoute: typeof AuthenticatedDevicesSplittersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices/onus': {
      id: '/_authenticated/devices/onus'
      path: '/devices/onus'
      fullPath: '/devices/onus'
      preLoaderRoute: typeof AuthenticatedDevicesOnusRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices/olts': {
      id: '/_authenticated/devices/olts'
      path: '/devices/olts'
      fullPath: '/devices/olts'
      preLoaderRoute: typeof AuthenticatedDevicesOltsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices/olt-cards': {
      id: '/_authenticated/devices/olt-cards'
      path: '/devices/olt-cards'
      fullPath: '/devices/olt-cards'
      preLoaderRoute: typeof AuthenticatedDevicesOltCardsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices/mikrotiks': {
      id: '/_authenticated/devices/mikrotiks'
      path: '/devices/mikrotiks'
      fullPath: '/devices/mikrotiks'
      preLoaderRoute: typeof AuthenticatedDevicesMikrotiksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/devices/coverage-areas': {
      id: '/_authenticated/devices/coverage-areas'
      path: '/devices/coverage-areas'
      fullPath: '/devices/coverage-areas'
      preLoaderRoute: typeof AuthenticatedDevicesCoverageAreasRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/new': {
      id: '/_authenticated/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AuthenticatedCustomersNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/$customerId': {
      id: '/_authenticated/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/invoices': {
      id: '/_authenticated/billing/invoices'
      path: '/billing/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof AuthenticatedBillingInvoicesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/hub-invoices': {
      id: '/_authenticated/billing/hub-invoices'
      path: '/billing/hub-invoices'
      fullPath: '/billing/hub-invoices'
      preLoaderRoute: typeof AuthenticatedBillingHubInvoicesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/discounts': {
      id: '/_authenticated/billing/discounts'
      path: '/billing/discounts'
      fullPath: '/billing/discounts'
      preLoaderRoute: typeof AuthenticatedBillingDiscountsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/discount-vouchers': {
      id: '/_authenticated/billing/discount-vouchers'
      path: '/billing/discount-vouchers'
      fullPath: '/billing/discount-vouchers'
      preLoaderRoute: typeof AuthenticatedBillingDiscountVouchersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/customer-points': {
      id: '/_authenticated/billing/customer-points'
      path: '/billing/customer-points'
      fullPath: '/billing/customer-points'
      preLoaderRoute: typeof AuthenticatedBillingCustomerPointsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/billing-cycles': {
      id: '/_authenticated/billing/billing-cycles'
      path: '/billing/billing-cycles'
      fullPath: '/billing/billing-cycles'
      preLoaderRoute: typeof AuthenticatedBillingBillingCyclesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operation/billing-run-history/': {
      id: '/_authenticated/operation/billing-run-history/'
      path: '/operation/billing-run-history'
      fullPath: '/operation/billing-run-history/'
      preLoaderRoute: typeof AuthenticatedOperationBillingRunHistoryIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operation/billing-engine-run/': {
      id: '/_authenticated/operation/billing-engine-run/'
      path: '/operation/billing-engine-run'
      fullPath: '/operation/billing-engine-run/'
      preLoaderRoute: typeof AuthenticatedOperationBillingEngineRunIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marketing/broadcast/': {
      id: '/_authenticated/marketing/broadcast/'
      path: '/marketing/broadcast'
      fullPath: '/marketing/broadcast/'
      preLoaderRoute: typeof AuthenticatedMarketingBroadcastIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operation/billing-run-history/$runId': {
      id: '/_authenticated/operation/billing-run-history/$runId'
      path: '/operation/billing-run-history/$runId'
      fullPath: '/operation/billing-run-history/$runId'
      preLoaderRoute: typeof AuthenticatedOperationBillingRunHistoryRunIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marketing/broadcast/new': {
      id: '/_authenticated/marketing/broadcast/new'
      path: '/marketing/broadcast/new'
      fullPath: '/marketing/broadcast/new'
      preLoaderRoute: typeof AuthenticatedMarketingBroadcastNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marketing/broadcast/$broadcastId': {
      id: '/_authenticated/marketing/broadcast/$broadcastId'
      path: '/marketing/broadcast/$broadcastId'
      fullPath: '/marketing/broadcast/$broadcastId'
      preLoaderRoute: typeof AuthenticatedMarketingBroadcastBroadcastIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProfileRouteRoute: typeof AuthenticatedProfileRouteRoute
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRoute
  AuthenticatedAuditLogsRoute: typeof AuthenticatedAuditLogsRoute
  AuthenticatedCeleryRoute: typeof AuthenticatedCeleryRoute
  AuthenticatedEmployeesRoute: typeof AuthenticatedEmployeesRoute
  AuthenticatedRolesRoute: typeof AuthenticatedRolesRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBillingBillingCyclesRoute: typeof AuthenticatedBillingBillingCyclesRoute
  AuthenticatedBillingCustomerPointsRoute: typeof AuthenticatedBillingCustomerPointsRoute
  AuthenticatedBillingDiscountVouchersRoute: typeof AuthenticatedBillingDiscountVouchersRoute
  AuthenticatedBillingDiscountsRoute: typeof AuthenticatedBillingDiscountsRoute
  AuthenticatedBillingHubInvoicesRoute: typeof AuthenticatedBillingHubInvoicesRoute
  AuthenticatedBillingInvoicesRoute: typeof AuthenticatedBillingInvoicesRoute
  AuthenticatedCustomersCustomerIdRoute: typeof AuthenticatedCustomersCustomerIdRoute
  AuthenticatedCustomersNewRoute: typeof AuthenticatedCustomersNewRoute
  AuthenticatedDevicesCoverageAreasRoute: typeof AuthenticatedDevicesCoverageAreasRoute
  AuthenticatedDevicesMikrotiksRoute: typeof AuthenticatedDevicesMikrotiksRoute
  AuthenticatedDevicesOltCardsRoute: typeof AuthenticatedDevicesOltCardsRoute
  AuthenticatedDevicesOltsRoute: typeof AuthenticatedDevicesOltsRoute
  AuthenticatedDevicesOnusRoute: typeof AuthenticatedDevicesOnusRoute
  AuthenticatedDevicesSplittersRoute: typeof AuthenticatedDevicesSplittersRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedInventoryControlRoute: typeof AuthenticatedInventoryControlRoute
  AuthenticatedInventoryDocumentsRoute: typeof AuthenticatedInventoryDocumentsRoute
  AuthenticatedInventoryLedgerRoute: typeof AuthenticatedInventoryLedgerRoute
  AuthenticatedInventoryMasterRoute: typeof AuthenticatedInventoryMasterRoute
  AuthenticatedInventoryMeRoute: typeof AuthenticatedInventoryMeRoute
  AuthenticatedInventoryStockRoute: typeof AuthenticatedInventoryStockRoute
  AuthenticatedInventoryWarehouseRoute: typeof AuthenticatedInventoryWarehouseRoute
  AuthenticatedMarketingTemplatesRoute: typeof AuthenticatedMarketingTemplatesRoute
  AuthenticatedMonitoringDownloadsRoute: typeof AuthenticatedMonitoringDownloadsRoute
  AuthenticatedMonitoringOltsRoute: typeof AuthenticatedMonitoringOltsRoute
  AuthenticatedMonitoringOnusRoute: typeof AuthenticatedMonitoringOnusRoute
  AuthenticatedMonitoringPppoeRoute: typeof AuthenticatedMonitoringPppoeRoute
  AuthenticatedMonitoringStatusMismatchRoute: typeof AuthenticatedMonitoringStatusMismatchRoute
  AuthenticatedMonitoringUnconfiguredRoute: typeof AuthenticatedMonitoringUnconfiguredRoute
  AuthenticatedOrdersOrderIdRoute: typeof AuthenticatedOrdersOrderIdRoute
  AuthenticatedOrdersNewRoute: typeof AuthenticatedOrdersNewRoute
  AuthenticatedProductsCategoriesRoute: typeof AuthenticatedProductsCategoriesRoute
  AuthenticatedSubscriptionsSubsIdRoute: typeof AuthenticatedSubscriptionsSubsIdRoute
  AuthenticatedSubscriptionsProvidersRoute: typeof AuthenticatedSubscriptionsProvidersRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedMonitoringIndexRoute: typeof AuthenticatedMonitoringIndexRoute
  AuthenticatedOrdersIndexRoute: typeof AuthenticatedOrdersIndexRoute
  AuthenticatedPartnersIndexRoute: typeof AuthenticatedPartnersIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedSubscriptionsIndexRoute: typeof AuthenticatedSubscriptionsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedMarketingBroadcastBroadcastIdRoute: typeof AuthenticatedMarketingBroadcastBroadcastIdRoute
  AuthenticatedMarketingBroadcastNewRoute: typeof AuthenticatedMarketingBroadcastNewRoute
  AuthenticatedOperationBillingRunHistoryRunIdRoute: typeof AuthenticatedOperationBillingRunHistoryRunIdRoute
  AuthenticatedMarketingBroadcastIndexRoute: typeof AuthenticatedMarketingBroadcastIndexRoute
  AuthenticatedOperationBillingEngineRunIndexRoute: typeof AuthenticatedOperationBillingEngineRunIndexRoute
  AuthenticatedOperationBillingRunHistoryIndexRoute: typeof AuthenticatedOperationBillingRunHistoryIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProfileRouteRoute: AuthenticatedProfileRouteRoute,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRoute,
  AuthenticatedAuditLogsRoute: AuthenticatedAuditLogsRoute,
  AuthenticatedCeleryRoute: AuthenticatedCeleryRoute,
  AuthenticatedEmployeesRoute: AuthenticatedEmployeesRoute,
  AuthenticatedRolesRoute: AuthenticatedRolesRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBillingBillingCyclesRoute:
    AuthenticatedBillingBillingCyclesRoute,
  AuthenticatedBillingCustomerPointsRoute:
    AuthenticatedBillingCustomerPointsRoute,
  AuthenticatedBillingDiscountVouchersRoute:
    AuthenticatedBillingDiscountVouchersRoute,
  AuthenticatedBillingDiscountsRoute: AuthenticatedBillingDiscountsRoute,
  AuthenticatedBillingHubInvoicesRoute: AuthenticatedBillingHubInvoicesRoute,
  AuthenticatedBillingInvoicesRoute: AuthenticatedBillingInvoicesRoute,
  AuthenticatedCustomersCustomerIdRoute: AuthenticatedCustomersCustomerIdRoute,
  AuthenticatedCustomersNewRoute: AuthenticatedCustomersNewRoute,
  AuthenticatedDevicesCoverageAreasRoute:
    AuthenticatedDevicesCoverageAreasRoute,
  AuthenticatedDevicesMikrotiksRoute: AuthenticatedDevicesMikrotiksRoute,
  AuthenticatedDevicesOltCardsRoute: AuthenticatedDevicesOltCardsRoute,
  AuthenticatedDevicesOltsRoute: AuthenticatedDevicesOltsRoute,
  AuthenticatedDevicesOnusRoute: AuthenticatedDevicesOnusRoute,
  AuthenticatedDevicesSplittersRoute: AuthenticatedDevicesSplittersRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedInventoryControlRoute: AuthenticatedInventoryControlRoute,
  AuthenticatedInventoryDocumentsRoute: AuthenticatedInventoryDocumentsRoute,
  AuthenticatedInventoryLedgerRoute: AuthenticatedInventoryLedgerRoute,
  AuthenticatedInventoryMasterRoute: AuthenticatedInventoryMasterRoute,
  AuthenticatedInventoryMeRoute: AuthenticatedInventoryMeRoute,
  AuthenticatedInventoryStockRoute: AuthenticatedInventoryStockRoute,
  AuthenticatedInventoryWarehouseRoute: AuthenticatedInventoryWarehouseRoute,
  AuthenticatedMarketingTemplatesRoute: AuthenticatedMarketingTemplatesRoute,
  AuthenticatedMonitoringDownloadsRoute: AuthenticatedMonitoringDownloadsRoute,
  AuthenticatedMonitoringOltsRoute: AuthenticatedMonitoringOltsRoute,
  AuthenticatedMonitoringOnusRoute: AuthenticatedMonitoringOnusRoute,
  AuthenticatedMonitoringPppoeRoute: AuthenticatedMonitoringPppoeRoute,
  AuthenticatedMonitoringStatusMismatchRoute:
    AuthenticatedMonitoringStatusMismatchRoute,
  AuthenticatedMonitoringUnconfiguredRoute:
    AuthenticatedMonitoringUnconfiguredRoute,
  AuthenticatedOrdersOrderIdRoute: AuthenticatedOrdersOrderIdRoute,
  AuthenticatedOrdersNewRoute: AuthenticatedOrdersNewRoute,
  AuthenticatedProductsCategoriesRoute: AuthenticatedProductsCategoriesRoute,
  AuthenticatedSubscriptionsSubsIdRoute: AuthenticatedSubscriptionsSubsIdRoute,
  AuthenticatedSubscriptionsProvidersRoute:
    AuthenticatedSubscriptionsProvidersRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedMonitoringIndexRoute: AuthenticatedMonitoringIndexRoute,
  AuthenticatedOrdersIndexRoute: AuthenticatedOrdersIndexRoute,
  AuthenticatedPartnersIndexRoute: AuthenticatedPartnersIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedSubscriptionsIndexRoute: AuthenticatedSubscriptionsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedMarketingBroadcastBroadcastIdRoute:
    AuthenticatedMarketingBroadcastBroadcastIdRoute,
  AuthenticatedMarketingBroadcastNewRoute:
    AuthenticatedMarketingBroadcastNewRoute,
  AuthenticatedOperationBillingRunHistoryRunIdRoute:
    AuthenticatedOperationBillingRunHistoryRunIdRoute,
  AuthenticatedMarketingBroadcastIndexRoute:
    AuthenticatedMarketingBroadcastIndexRoute,
  AuthenticatedOperationBillingEngineRunIndexRoute:
    AuthenticatedOperationBillingEngineRunIndexRoute,
  AuthenticatedOperationBillingRunHistoryIndexRoute:
    AuthenticatedOperationBillingRunHistoryIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
